import { render, staticRenderFns } from "./lead-center-charts-activities.component.vue?vue&type=template&id=3cb4af64&scoped=true&"
import script from "./lead-center-charts-activities.component.vue?vue&type=script&lang=js&"
export * from "./lead-center-charts-activities.component.vue?vue&type=script&lang=js&"
import style0 from "./lead-center-charts-activities.component.vue?vue&type=style&index=0&id=3cb4af64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4af64",
  null
  
)

export default component.exports